import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserProfileDropdown } from './UserProfileDropdown';
import { NotificationDropdown } from './NotificationDropdown';
import { MessagesDropdown } from './MessagesDropdown';
import { BeltDisplay } from './BeltDisplay';
import { BadgesDropdown } from './BadgesDropdown';
import { PointsDropdown } from './PointsDropdown';
import { useAuth } from '@/features/auth/AuthProvider';

interface TopBarProps {
    onMenuClick?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({ onMenuClick }) => {
    const { isImpersonating } = useAuth();

    return (
        <header className={`fixed inset-x-0 min-h-16 bg-white shadow-sm z-50 px-4 pt-safe flex items-center justify-between ${isImpersonating ? 'top-10' : 'top-0'}`}>
            {/* Left: Logo & Mobile Menu */}
            <div className="flex items-center gap-4 flex-1 justify-start">
                <Button
                    variant="ghost"
                    size="icon"
                    className="lg:hidden text-gray-500"
                    onClick={onMenuClick}
                    aria-label="Toggle menu"
                >
                    <Menu className="h-6 w-6" />
                </Button>
                {/* Logo: Hidden on mobile, visible on lg+ */}
                <Link to="/dashboard" className="hidden lg:flex items-center gap-3">
                    <img src="/logo.png" alt="ADJJA Academy" className="w-10 h-10 rounded-full object-cover border border-gray-100" />
                    <span className="text-xl font-bold text-black tracking-tight">ADJJA Academy</span>
                </Link>
            </div>

            {/* Points now in profile dropdown on mobile */}

            {/* Right: Gamification & Actions */}
            <div className="flex items-center gap-2 sm:gap-3 flex-1 justify-end">
                {/* Gamification Group: Belt and Badges hidden on mobile */}
                <div className="hidden md:flex items-center gap-2 md:gap-3 me-1 md:me-2 border-e pe-2 md:pe-4 border-gray-100/50">
                    <BeltDisplay />
                    <BadgesDropdown />
                    <PointsDropdown />
                </div>

                {/* Communication Group */}
                <div className="flex items-center gap-2 sm:gap-3">
                    {/* Messages */}
                    <MessagesDropdown />

                    {/* Notifications */}
                    <div data-tour="notifications">
                        <NotificationDropdown />
                    </div>

                    <div data-tour="profile-menu">
                        <UserProfileDropdown />
                    </div>
                </div>
            </div>
        </header>
    );
};

